import { type ReactNode, useState } from 'react';
import { AccountApprovalContext, type AccountApprovalContextType } from './account-approval-context';
import { AccountApprovalActions, type AccountApprovalActionsType } from './account-approval-context-actions';

interface AccountApprovalContextProviderProps {
    children: ReactNode;
}

export const AccountApprovalContextProvider = ({ children }: AccountApprovalContextProviderProps) => {
    const [approverParentEmail, setApproverParentEmail] = useState<string | null>(null);
    const [approverParentHasGivenConsent, setApproverParentHasGivenConsent] = useState<boolean>(false);

    const accountApprovalContext: AccountApprovalContextType = {
        approverParentEmail,
        approverParentHasGivenConsent,
    };

    const accountApprovalActions: AccountApprovalActionsType = {
        setApproverParentEmail,
        setApproverParentHasGivenConsent,
    };

    return (
        <AccountApprovalContext.Provider value={accountApprovalContext}>
            <AccountApprovalActions.Provider value={accountApprovalActions}>{children}</AccountApprovalActions.Provider>
        </AccountApprovalContext.Provider>
    );
};
